import { HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs/operators';

export const debugInterceptor: HttpInterceptorFn = (req, next) => {
  // Solo loggear requests a /api/
  // if (req.url.includes('/api/')) {
  //   console.log('🌐 HTTP Request:', {
  //     method: req.method,
  //     url: req.url,
  //     params: req.params.toString(),
  //   });
  // }

  return next(req).pipe(
    tap(
      (event) => {
        if (req.url.includes('/api/')) {
          // console.log('✅ HTTP Response:', {
          //   status: (event as any).status,
          //   url: req.url,
          //   body: (event as any).body,
          // });
        }
      },
      (error) => {
        // if (req.url.includes('/api/')) {
        //   console.error('❌ HTTP Error:', {
        //     status: error.status,
        //     url: req.url,
        //     message: error.message,
        //     error: error.error,
        //   });
        // }
      }
    )
  );
};
